<template>
    <div
        :id="id"
        class="common-range--multi"
    >
        <FieldItem
            class="common-range"
            :label="$t('Search.labels.subjectNucLength')"
        >
            <div class="common-range-group">
                <div class="common-range-group__input">
                    <input
                        v-model="fieldValue.nucleotide[0]"
                        :maxlength="9"
                        style="text-align:right"
                        type="text"
                        @keypress="isNumber($event)"
                        @blur="syncChange"
                    >
                </div>
                <div class="common-range-group__separator" />
                <div class="common-range-group__input">
                    <input
                        v-model="fieldValue.nucleotide[1]"
                        :maxlength="9"
                        placeholder="∞"
                        type="text"
                        style="text-align:left"
                        @keypress="isNumber($event)"
                        @blur="syncChange"
                    >
                </div>
            </div>
        </FieldItem>
        <FieldItem
            class="common-range"
            :label="$t('Search.labels.subjectProteinLength')"
        >
            <div class="common-range-group">
                <div class="common-range-group__input">
                    <input
                        v-model="fieldValue.protein[0]"
                        :maxlength="9"
                        style="text-align:right"
                        type="text"
                        @keypress="isNumber($event)"
                        @blur="syncChange"
                    >
                </div>
                <div class="common-range-group__separator" />
                <div class="common-range-group__input">
                    <input
                        v-model="fieldValue.protein[1]"
                        :maxlength="9"
                        placeholder="∞"
                        type="text"
                        style="text-align:left"
                        @keypress="isNumber($event)"
                        @blur="syncChange"
                    >
                </div>
            </div>
        </FieldItem>
    </div>
</template>

<script>
import FieldItem from '../components/FieldItem.vue';
import { FieldItemMixin } from './mixins';

export default {
    components: {
        FieldItem,
    },
    mixins: [FieldItemMixin],
    inject: ['store'],
    props: {
        fieldName: {
            type: String,
            default: 'multi_subject_length',
        },
    },
};
</script>
